import { render } from "./EnderecosPessoa.vue?vue&type=template&id=0c0fbf1b&scoped=true&ts=true"
import script from "./EnderecosPessoa.vue?vue&type=script&lang=ts"
export * from "./EnderecosPessoa.vue?vue&type=script&lang=ts"

import "./EnderecosPessoa.vue?vue&type=style&index=0&id=0c0fbf1b&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0fbf1b"]])

export default __exports__